import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {useSelector} from 'react-redux'
import paths from './paths'

export const isAuthenticated = (state) => {
  // Check for auth state
  if (!state || !state.auth) return false;
  
  // Check for user object
  if (!state.auth.user) return false;
  
  // Check provider-specific authentication
  const { provider } = state.auth;
  
  if (provider === 'google' || provider === 'microsoft') {
    // Existing logic for Google and Microsoft
    return Boolean(state.auth.isAuthenticated && state.auth.user);
  }
  
  if (provider === 'mylogin') {
    // Check for MyLogin-specific auth
    const accessToken = localStorage.getItem('mylogin_access_token');
    const expiresAt = localStorage.getItem('mylogin_expires_at');
    const isValid = accessToken && expiresAt && Number(expiresAt) > Date.now();
    
    return Boolean(state.auth.isAuthenticated && state.auth.user && isValid);
  }
  
  if (provider === 'email') {
    // For email login, just check if we have user data in state and localStorage
    const pupilData = localStorage.getItem('pupil');
    return Boolean(state.auth.isAuthenticated && state.auth.user && pupilData);
  }
  
  // Default check for other providers or when provider is not specified
  return Boolean(state.auth.isAuthenticated && state.auth.user);
};

const ProtectedRoute = () => {
  const skipStorage = ['/login', '/login-redirect']
  if (!skipStorage.includes(window.location.pathname)) {
    const url = window.location.pathname + window.location.search;
    localStorage.setItem('auth_redirect_url', url);
  }
  
  // Use the proper authentication check function
  const state = useSelector(state => state);
  const authenticated = isAuthenticated(state);
  
  // If we already have pupil data in localStorage but not in state, it's possible
  // the Redux state was lost (e.g., on refresh) but we're still authenticated
  if (!authenticated && localStorage.getItem('pupil')) {
    return <Outlet />;
  }
  
  return authenticated ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoute
